exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_when__1lHKf abbr[title]{text-decoration:none;cursor:help;border-bottom:.05rem dotted #777}", ""]);

// exports
exports.locals = {
	"when": "style_when__1lHKf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/TimeLabels/style.less
// module id = 1790
// module chunks = 8